import { defineMessages } from 'react-intl';

const parkingAdminMessages = defineMessages({
    systemId: {
        id: 'system-id',
        defaultMessage: 'System ID',
    },
    serialId: {
        id: 'serial-id',
        defaultMessage: 'Serial ID',
    },
    status: {
        id: 'status',
        defaultMessage: 'Status',
    },
    publicParking: {
        id: 'public-parking',
        defaultMessage: 'Public parking',
    },
    parkings: {
        id: 'parkings',
        defaultMessage: 'Parkings',
    },
    parking: {
        id: 'parking',
        defaultMessage: 'Parking',
    },
    parkingsCount: {
        id: 'parkings-count',
        defaultMessage: 'Parkings',
    },
    onlinePayments: {
        id: 'online-payments',
        defaultMessage: 'Online payments',
    },
    reservations: {
        id: 'reservations',
        defaultMessage: 'Reservations',
    },
    isFeatured: {
        id: 'is-featured',
        defaultMessage: 'Featured in website',
    },
    addNewParking: {
        id: 'add-new-parking',
        defaultMessage: 'Add new parking',
    },
    numberOfFloors: {
        id: 'number-of-floors',
        defaultMessage: 'Number of floors',
    },
    numberOfSpaces: {
        id: 'number-of-spaces',
        defaultMessage: 'Number of spaces',
    },
    createdSuccessfully: {
        id: 'created-successfully',
        defaultMessage: 'Created successfully',
    },
    createParkingSuccessfulDescription: {
        id: 'create-parking-successful-description',
        defaultMessage: 'A new parking has been successfully created.',
    },
});

export default parkingAdminMessages;
